import { BrowserRouter, Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import Add from "./pages/Add";
import Edit from "./pages/Edit";
import Home from "./pages/Home";

export default function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/books/add" element={<Add />}></Route>
        <Route path="/books/edit/:bookId" element={<Edit />}></Route>
      </Routes>
    </BrowserRouter>
  );
}
